import $ from 'jquery'

window.$ = $;
window.jQuery = $;

import Raven from 'raven-js'
//Raven.config('https://6bcb50317d3a48d7baaaff4c3ca42cba@sentry.io/232960').install()
